import { API_URL } from "../../utils/contextHelpers";
import { api } from "./core";

export const getFicha = api("getCuentaBancaria", (tenant_id) => `${API_URL}cuentaBancaria/activas?tenant_id=${encodeURIComponent(tenant_id)}`);
